import { Card, List, Modal } from 'antd'
import { useState } from 'react'
import defaultConfigs from './defaultConfigs'
import { getComponentIcon } from 'Services/ActionsPagesUtils'
import styled from 'styled-components'
import './AutofillModal.scss'

ItemList = ({ onChange }) ->
  [active, setActive] = useState(0)
  <List
    grid={{ gutter: 16, column: 4 }}
    dataSource={defaultConfigs}
    style={{ padding: 20 }}
    className="autofill-items-container"
    renderItem={(item, i) ->
      imgSrc = getComponentIcon(item.component)
      <StyledListItem
        onClick={->
          setActive(i)
          onChange(defaultConfigs[i])
        }
        style={{ borderColor: active is i && '#58bd91' }}
      >
        <img src={imgSrc} style={{ height: 100, marginTop: 10 }} />
        <h4 style={{ marginTop: 15 }} >{ item.title }</h4>
      </StyledListItem>
    }
  />

export default showAutofillModal = (onChange) ->
  Modal.info({
    content: <ItemList onChange={onChange} />
    width: '80%'
    title: 'Choose a template for the service.'
  })

StyledListItem = styled(List.Item)"""
  text-align: center;
  background: var(--backgroundColor);
  padding: 20px;
  border-radius: 15px;
  border: 1px solid var(--borderColor);
  height: 200px;
  cursor: pointer;
"""

